const catalogs = new WeakMap()

export function localizedText(element, key, values = {}) {
  const root = element.ownerDocument.body
  if (!catalogs.has(root)) {
    catalogs.set(root, JSON.parse(root.dataset.localization))
  }
  const messages = catalogs.get(root)
  const message = messages[key]
  const text = typeof message === "string" ? message : message[new Intl.PluralRules(root.lang).select(values.count)]
  return text.replace(/%\{(\w+)\}/g, (_, name) => values[name])
}
